import { useMemo } from "react";
import MissPunchModal from "../Actions/MissPunchModal";
import { useVisible } from "../../../../utils/hooks/useVisible"

export const useMissPunchModal = ({ missPunchRequest }) => {
    const { visible, close, open, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <MissPunchModal 
                visible={visible}
                values={selected}
                close={close}
                submit={missPunchRequest}
            />
        )
    }, [close, selected, visible, missPunchRequest]);

    return { open, modal };
}
